/**
 * This module manages the jobs model of the API
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
// import isEqual from 'lodash/isEqual'
// import isEqualWith from 'lodash/isEqualWith'
// import clone from 'lodash/clone'
import axios from 'axios'
import exportToExcel from '@/helpers/exportToExcel.js'

import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import omit from 'lodash/omit'

import Vue from 'vue'
import api from '@/api'
import store from '@/store'
import router from '@/router'

import {
    VUEX_JOBS_EXIT_JOB,
    VUEX_JOBS_EXIT_JOBS,

    // JOBS
    VUEX_JOBS_GET_REQUEST,
    VUEX_JOBS_GET_SUCCESS,
    VUEX_JOBS_GET_FAILURE,

    VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY,
    VUEX_JOBS_APPLY_FILTERS,
    VUEX_JOBS_CLEAR_FILTERS,
    VUEX_JOBS_RESET_FILTERS,
    VUEX_JOBS_SET_FILTER_TOGGLER,
    VUEX_JOBS_STORE_QUICK_FILTER,
    VUEX_JOBS_APPLY_FILTER_BY_NAME,
    VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME,

    VUEX_JOBS_APPLY_USER_ME_IN_ROLE,
    VUEX_JOBS_REMOVE_USER_ME_IN_ROLE,
    VUEX_JOBS_REMOVE_USER_ALL_REQUESTS_MY_DRAFTS,

    VUEX_JOBS_APPLY_ARCHIVE_FILTER,
    VUEX_JOBS_APPLY_STATUS_FILTER,
    VUEX_JOBS_APPLY_PROGRESS_FILTER,
    VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER,
    VUEX_JOBS_APPLY_TYPE_FILTER,
    VUEX_JOBS_APPLY_DEPARTMENT_FILTER,
    VUEX_JOBS_APPLY_DUE_FILTER,
    VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER,


    VUEX_JOBS_APPLY_USER_REQUESTOR,
    VUEX_JOBS_APPLY_USER_PROJECT_MANAGER,
    VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER,
    VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER,
    VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR,
    VUEX_JOBS_APPLY_USER_CREATIVE,

    VUEX_JOBS_SYNC_PAGINATION,
    VUEX_JOBS_SYNC_PAGINATION_SORT,
    VUEX_JOBS_APPLY_DEEPSTATE,
    VUEX_JOBS_APPLY_QUICK_FILTER,
    VUEX_JOBS_TEXT_FILTER_SEARCH,
    VUEX_JOBS_CLEAR_TEXT_FILTER_SEARCH,
    VUEX_JOBS_SET_APPROVED,
    VUEX_JOBS_GET_PROGRESSES_REQUEST,
    VUEX_JOBS_SET_PAGINATION_PER_PAGE,

    // JOB
    VUEX_JOBS_GET_REQUEST_FOR_EXCEL,
    VUEX_JOB_GET_REQUEST,
    VUEX_JOB_GET_SUCCESS,
    VUEX_JOB_GET_FAILURE,
    VUEX_JOB_DELETE,
    VUEX_JOB_UPDATE_PROP,
    VUEX_JOB_UPDATE_24HOUR_CONFIRMED,
    VUEX_JOB_UPDATE_DELIVERY_OPTION_PROP,
    VUEX_JOB_UPDATE_DELVIERY_OPTION_REQUEST,
    VUEX_JOB_UPDATE_REQUEST,
    VUEX_JOB_UPDATE_REQUEST_SUCCESS,
    VUEX_JOB_UPDATE_REQUEST_FAILURE,
    VUEX_JOB_PRINT_GET_REQUEST,
    VUEX_JOB_PRINT_GET_REQUEST_SUCCESS,

    // TODO: Remove all _FILES_ ? | Started using _ATTACHMENTS_
    VUEX_JOB_GET_FILES,
    VUEX_JOB_GET_FILES_SUCCESS,
    VUEX_JOB_GET_WATCHES,
    VUEX_JOB_GET_WATCHES_SUCCESS,

    // Comments
    VUEX_JOB_GET_COMMENTS,
    VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST,
    VUEX_JOB_GET_COMMENTS_SUCCESS,
    VUEX_JOB_GET_COMMENTS_FAILURE,
    VUEX_JOB_GET_COMMENTS_ABORT,
    VUEX_JOB_GET_COMMENT,
    VUEX_JOB_GET_COMMENT_SUCCESS,
    VUEX_JOB_ADD_COMMENT,
    VUEX_JOB_ADD_COMMENT_SUCCESS,
    VUEX_JOB_ADD_UNPUBLISHED_COMMENT,
    VUEX_JOB_ADD_UNPUBLISHED_COMMENT_SUCCESS,
    VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_TEXT,
    VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_SET_HAS_ATTACHMENTS,
    VUEX_JOB_CLEAR_UNPUBLISHED_COMMENT,
    VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG,
    VUEX_JOB_CLEAR_TEARDOWN_COMMENT_FLAG,
    VUEX_JOB_UPDATE_COMMENT,
    VUEX_JOB_UPDATE_COMMENT_SUCCESS,
    VUEX_JOB_REMOVE_COMMENT,
    VUEX_JOB_REMOVE_COMMENT_SUCCESS,

    // Team
    VUEX_JOB_GET_TEAM,
    VUEX_JOB_TEAM_ADD_MEMBER,
    VUEX_JOB_TEAM_ADD_MEMBER_SUCCESS,
    VUEX_JOB_TEAM_ADD_MEMBER_FAILURE,
    VUEX_JOB_TEAM_REMOVE_MEMBER,
    VUEX_JOB_TEAM_REMOVE_MEMBER_SUCCESS,
    VUEX_JOB_TEAM_REMOVE_MEMBER_FAILURE,

    VUEX_JOB_WATCH,
    VUEX_JOB_WATCH_SUCCESS,
    VUEX_JOB_UNWATCH,
    VUEX_JOB_UNWATCH_SUCCESS,
    VUEX_JOB_FLAG,
    VUEX_JOB_FLAG_SUCCESS,
    VUEX_JOB_UNFLAG,
    VUEX_JOB_UNFLAG_SUCCESS,

    // CREATE JOB
    VUEX_JOB_CREATE_INIT,
    VUEX_JOB_CREATE_INIT_MILESTONES_DONE,
    VUEX_JOB_CREATE,
    VUEX_JOB_CREATE_UI,
    VUEX_JOB_CREATE_APPLY_TEMPLATE,
    VUEX_JOB_CREATE_SUCCESS,
    VUEX_JOB_CREATE_FAILURE,
    VUEX_JOB_CREATE_LOAD,
    VUEX_JOB_CREATE_UPDATE,
    VUEX_JOB_CREATE_UPDATE_SUCCESS,
    VUEX_JOB_CREATE_UPDATE_FAILURE,
    VUEX_JOB_CREATE_UPDATE_PROP,
    VUEX_JOB_CREATE_HAS_CHANGED,
    VUEX_JOB_CREATE_CANCEL,
    VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE,
    VUEX_JOB_CREATE_CLEAR_DELIVERY_OPTIONS,
    VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP,
    VUEX_JOB_CREATE_CANCEL_PROMPT,

    // TRANSITION JOB
    VUEX_JOB_TRANSITION,
    VUEX_JOB_TRANSITION_SUCCESS,
    VUEX_JOB_TRANSITION_FAILURE,

    //SEARCH
    VUEX_JOB_GET_SEARCH,
    VUEX_JOB_GET_SEARCH_SUCCESS,
    VUEX_JOB_GET_SEARCH_FAILURE,
    VUEX_JOB_CLEAR_SEARCH_DATA,
    VUEX_JOB_UPDATE_SEARCH_TERM,

    // File attachment
    VUEX_JOB_ATTACH_FILE,
    VUEX_JOB_REMOVE_FILE,
    VUEX_JOB_REMOVE_FILE_SUCCESS,
    VUEX_JOB_COMMENT_ATTACH_FILE,
    VUEX_JOB_COMMENT_REMOVE_FILE,
    VUEX_JOB_COMMENT_REMOVE_FILE_SUCCESS,
    VUEX_JOB_GET_ATTACHMENTS,
    VUEX_JOB_GET_ATTACHMENTS_SUCCESS,
    VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM,
    // VUEX_JOB_GET_ATTACHMENTS_FAILURE,

    // On File notification
    VUEX_JOB_REPLACE_FILE_ON_COMMENT_ATTACHMENT,
    VUEX_JOB_REPLACE_FILE_ON_JOB_ATTACHMENT,

    // used in resource allocation
    VUEX_JOBS_ROUTE_CREATIVE_FROM_RESOURCE_ALLOCATION,

    // Print / PDF
    VUEX_JOB_GENERATE_PRINT_PDF,

    // LIKE / UNLIKE Comment
    VUEX_JOB_LIKE_COMMENT,
    VUEX_JOB_UNLIKE_COMMENT,


    //cancels
    VUEX_JOBS_SET_CANCEL,

} from '@/store/constants/jobs'

import {
    VUEX_PREMEDIA_CLEAR_DATA,
    VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS
} from '@/store/constants/premedia'

import {
    VUEX_UI_PROGRESS_COLUMNS,
    VUEX_UI_HIDE_JOB_SEARCH,
    VUEX_UI_HIDE_JOB_SEARCH_MOBILE,
    VUEX_UI_HIDE_JOB_PRINT_OVERLAY,
    VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY,
} from '@/store/constants/ui'

import {
    VUEX_ROUTING_ENTER_JOB
} from '@/store/constants/routing'

import {
    VUEX_AUTH_LOGOUT,
    VUEX_AUTH_REFRESH_FROM_TOKEN
} from '@/store/constants/auth'

import {
    VUEX_PERSISTENCE_SET_VALUE
} from '@/store/constants/persistence'

import {
    VUEX_ATTACHMENTS_DELETE_ATTACHMENT
} from '@/store/constants/attachments'

import {
    VUEX_SNACKBAR_SHOW
} from '@/store/constants/snackbar'



//An empty representation of a job object model needed for new job creation
const createJob_Template = {
    approver: null,
    approver_id: "",
    code: 0,
    created_at: {},
    creative_round: 0,
    date_approved: null,
    date_delivery: null,
    date_first_comp: null,
    date_premedia: null,
    date_release: null,
    date_submitted: null,
    date: "",
    delivery_instructions: "<p><br></p>",
    department: 0,
    directions: "<p><br></p>",
    id: "",
    international_subdepartment: 1,
    is_new_box:false,
    is_24_hour_rush: false,
    is_request: true,
    job_number: "",
    name: "",
    priority: 1,
    priority_note: "",
    priority_requested_delivery_date: "",
    priority_requested_first_comp_date: "",
    priority_supervisor_name: "",
    progress: 0,
    progress_note: 0,
    requestor: {},
    active: null,
    requestor_id: "",
    sila_one_job_number: "",
    specifications: "<p><br></p>",
    state: 'draft',
    status: 0,
    timezone: "",
    timezone_type: null,
    type: 0,
    updated_at: {},
    delivery_options: {
        hires_jpeg: false,
        hires_pdf: false,
        hires_pdf_cropmarks: false,
        hires_pdf_dielines: false,
        hires_pdf_fullbleed: false,
        hires_pdf_slug: false,
        hires_tiff: false,
        other: false,
        print_delivery_type: 1,
        requires_custom_ftp: false,
        vector_eps: false,
        web_ftp_jpeg: false,
        web_ftp_working_files: false,
        web_html: false,
        web_jpeg: false,
        web_pdf: false,
        web_psd: false,
        working_files_for_print: false,
        working_idml_files: false,
        working_indd_files: false,
        multimedia_drop_ftp: false,
        multimedia_account_ftp: false,
    },
}

const paginationDefault = {
    lastPage: 1,
    nextPage: null,
    page: 1,
    rowsPerPage: 100,
    totalItems: 0,
}

/**
 * Jobs module state
 * @const
 */
const state = {

    // State: Jobs list core
    jobs: [],
    jobsMeta: [],
    jobsLinks: {},
    jobsLoaded: false,
    jobsApproved: true,

    // State: Jobs pagination
    appliedFilters: [],
    pagination: {
        rowsPerPage: 10,
        page: 1
    },
    prevRowsPerPage: 10,

    // State: Job
    job: {},
    jobLinks: {},
    jobWatches: [],
    jobLoaded: false,
    didMileStoneDoneOnce: false,
    job24RushCancelConfirmed: false,

    jobTeam: [],

    // State: Job Comments
    jobComments: [],
    jobCommentsLinks: [],
    commentsLoading: false,
    newJobCommentsRequest: false,

    // State: Job comment pagination
    commentPagination: {
        lastPage: 1,
        nextPage: null,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
    },

    // State: Comment saving monitor
    jobComment_IsSaving: false,
    jobComment_IsSaved: false,

    // State: Pending comment (for attachments)
    jobPendingComment: null,
    jobPendingCommentText: null,
    jobPendingCommentHasAttachments: false,
    jobCommentTeardownFlag: false,

    // State: Job attachments
    jobFiles: {},
    jobAttachments: [],
    jobRemovedCheckedFilesToggler:'',

    // State: Create Job
    createJob_Data: {},
    createJob_PropsToUpdate: {},
    createJob_IsSaved: false,
    createJob_IsSaving: false,
    createJob_HasChanged: false,
    createJob_CancelPrompt: false,

    // State: Transition
    inTransition: false,

    // State: quick filter related
    filterToggler: '',
    currentQuickFilter: {},


    // State: JOB SEARCH
    searchData: [],                   // Search data from API
    searchTerm: null,                 // Search term entered by user
    searchLoading: false,             // If are currently being looked up



    //cancels
    cancels: {
        cancelCommentRequest:null,
        cancelWatchesRequest:null,
        cancelAttachmentsRequest:null,
    }

}


const getters = {

    getJob: state => {
        if (state.jobLoaded)
            return state.job
        return []
    },

    getDeliveryOptions: state => {
        if (state.jobLoaded)
            return state.job
        return {}
    },

    /**
     * This getter returns the comments attached to the currently loaded job
     * @function
     * @param {state} state
     */
    getJobComments: state => {
        if (state.jobLoaded)
            return state.job.comments
        return []
    },

    /**
     * This getter returns the files attached to the currently loaded job
     * @function
     * @param {state} state
     */
    getJobFiles: state => {
        if (state.jobLoaded)
            return state.jobFiles
        return []
    },

    /**
     * This getter returns the team members attached to the currently loaded job
     * @function
     * @param {state} state
     */
    /*getJobTeam: state => {
        if (state.jobLoaded)
            return state.job.team
        return []
    },*/

    /**
     * This getter is the same as getJobTeam, but filters it down to be unique people
     * @function
     * @param {state} state
     */
    getJobTeamUnique: state => {
        var ret = []
        if (state.jobLoaded) {
            let retunique = {}
            for (var i in state.jobTeam) {
                var obj = state.jobTeam[i]
                let uid = obj.user_id
                if (retunique.hasOwnProperty(uid) === false) {
                    retunique[uid] = 1
                    ret.push(obj)
                }
            }
        }
        return ret
    },

    /**
     * This getter returns the swaps attached to the currently loaded job
     * @function
     * @param {state} state
     */
    getJobSwapRows: state => {
        if (state.jobLoaded)
            return state.job.swapRows
        return []
    },

    /**
     * This getter returns the swaps attached to the currently loaded job
     * @function
     * @param {state} state
     */
    getJobId: state => {
        if (state.jobLoaded)
            return state.job.id
        return null
    },

    /**
     * This getter returns the swaps attached to the currently loaded job
     * @function
     * @param {state} state
     */
    getCreateJobData: state => {
        return state.createJob_Data
    },

    /**
     * This getter returns the pagination
     * @function
     * @param {state} state
     */
    getPagination: state => {
        return state.pagination
    },

    /**
     * This getter returns the job creation state ( isSaved, isSaving, canSave)
     * @function
     * @param {state} state
     */
    getCreateJobStatus: state => {
        return {
            isSaving: state.createJob_IsSaving,
            isSaved: state.createJob_IsSaved,
            hasChanged: state.createJob_HasChanged
        }
    },

    /**
     *
     * @param state
     * @returns {function(*): string}
     */
    getFilterCount: (state) => (obj) => {
        var id = obj.id;
        var ret = '';

        if (state.jobsMeta &&
            state.jobsMeta.hasOwnProperty('filter_counts') &&
            state.jobsMeta.filter_counts.hasOwnProperty(id)) {
            ret = state.jobsMeta.filter_counts.hasOwnProperty(id) ? state.jobsMeta.filter_counts[id] : ret;
        }
        return String(ret);
    },


    /**
     * This gets the current number of roles a user has relative to the job view filters
     * @param state,getters
     * @returns count
     */
    getUserMeInRoleObject: (state, getters) => {
        var currentUser = getters.getCurrentUser

        // Return if we don't have consts yet
        if (!getters.constantsAreLoaded) {
            return
        }

        // usermMeInRole is default for 0 and more than 1
        var obj = {}
        obj.count = 0
        obj.filterOn = 'userMeInRole' //default
        obj.value = 1

        if (getters.currentUserHasRole(SILA_ROLE_JOBS_REQUESTOR)) {
            obj.count += 1
            obj.filterOn = 'userRequestor'
            obj.value = currentUser.id
        }
        if (getters.currentUserHasRole(SILA_ROLE_JOBS_CREATIVE)) {
            obj.count += 1
            obj.filterOn = 'userCreative'
            obj.value = currentUser.id
        }
        if (getters.currentUserHasRole(SILA_ROLE_JOBS_ART_DIRECTOR)) {
            obj.count += 1
            obj.filterOn = 'userArtDirector'
            obj.value = currentUser.id
        }
        if (getters.currentUserHasRole(SILA_ROLE_JOBS_PREMEDIA_PROJECT_MANAGER)) {
            obj.count += 1
            obj.filterOn = 'userPremediaProjectManager'
            obj.value = currentUser.id
        }
        if (getters.currentUserHasRole(SILA_ROLE_JOBS_PRINT_PROJECT_MANAGER)) {
            obj.count += 1
            obj.filterOn = 'userPrintProjectManager'
            obj.value = currentUser.id
        }
        if (getters.currentUserHasRole(SILA_ROLE_JOBS_PROJECT_MANAGER)) {
            obj.count += 1
            obj.filterOn = 'userProjectManager'
            obj.value = currentUser.id
        }
        if (obj.count > 1) {
            obj.filterOn = 'userMeInRole'
            obj.value = 1
        }
        return obj;
    },


    //search data
    getSearchData: (state) => () => state.searchData,

    //archived global setting
    getArchiveGlobalSetting: (state) => {
        let ret = 'active' //default to active
        let idx = state.appliedFilters.findIndex(x => x.filterOn === 'archived')
        if (idx >-1) {
            ret = state.appliedFilters[idx].value
        }
        return ret
    },

}


/**
 * Jobs module action definitions
 * @const
 */
const actions = {
    //exit jobs
    [VUEX_JOBS_EXIT_JOBS]: ({state, commit, dispatch}, key) => {
        //!!PERSISTENCE
        if (key === 'requests') { //is job
            key = "requests"
        } else {
            key = "jobs"
        }

        var dsobj = {}
        dsobj.currentQuickFilter = cloneDeep(state.currentQuickFilter)
        dsobj.appliedFilters = cloneDeep(state.appliedFilters)
        dsobj.pagination = cloneDeep(state.pagination)
        var obj = {
            key: key,
            value: dsobj
        }
        dispatch(VUEX_PERSISTENCE_SET_VALUE, obj)


        //clear out search if open
        dispatch(VUEX_UI_HIDE_JOB_SEARCH)
        dispatch(VUEX_UI_HIDE_JOB_SEARCH_MOBILE)

        commit(VUEX_JOBS_EXIT_JOBS)
    },

    //exit job
    [VUEX_JOBS_EXIT_JOB]: async ({commit,dispatch}, key) => {
        //clear premedia so it doesn't flash when you load in the next job
        //also, if you are doing a new job, you don't want premedia to flash there either accidentally
        dispatch(VUEX_PREMEDIA_CLEAR_DATA)

        await commit(VUEX_JOBS_EXIT_JOB)
    },

    //routing from resource allocation
    [VUEX_JOBS_ROUTE_CREATIVE_FROM_RESOURCE_ALLOCATION]: async ({dispatch}, user) => {
        //set up deep link

        var obj, dsobj = {}
        dsobj.currentQuickFilter = ''

        dsobj.appliedFilters = []
        obj = {
            filterOn: 'userCreative',
            value: user.id,
        }
        dsobj.appliedFilters.push(obj)
        obj = {
            filterOn: 'status',
            value: 9,
        }
        dsobj.appliedFilters.push(obj)


        dsobj.pagination = {
            rowsPerPage: 10,
            page: 1,
            sortBy: 'dateDelivery',
            descending: true,
        }
        obj = {
            key: 'jobs',
            value: dsobj
        }

        await dispatch(VUEX_PERSISTENCE_SET_VALUE, obj)

        router.push({name: 'jobs-manage', params: {}})
    },


    /**
     * Get all jobs
     * Params :
     approved: (approved jobs | job requests)
     ...table pagination (sorting, page, itemsPerRow, etc)
     filters
     * @function
     */
    [VUEX_JOBS_GET_REQUEST]: async ({state, commit, dispatch}, extraParams) => {
        commit(VUEX_JOBS_GET_REQUEST, {})
        let route = router.currentRoute.name
        let isJobsApproved = (route === 'tools-routing') ? true : state.jobsApproved
        const filteredParams = omit(extraParams || {}, ['shouldPersistJobs', 'filter'])
        let params = Object.assign(
            {
                isJob: isJobsApproved,
                page: state.pagination.page,
                per_page: state.pagination.rowsPerPage,
            },
            filteredParams
        )
        if (state.pagination && state.pagination.sortBy) {
            params['sort'] = state.pagination.descending ? '-' + state.pagination.sortBy : state.pagination.sortBy
        }

        //explicity add the icon for routing
        if (route === 'tools-routing') {
            params['include'] = 'avatar'
        }

        //set archived if not set
        var archivedSet = false
        for (var f in state.appliedFilters) {
            if (state.appliedFilters[f].filterOn === 'archived') {
                archivedSet = true
                break
            }
        }
        if (archivedSet === false) {
            let newFilterItem = {}
            newFilterItem.filterOn = 'archived'
            newFilterItem.value = 'active'
            await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)
        }


        //loop through applied filters and turn to params
        for (var f in state.appliedFilters) {
            var key = state.appliedFilters[f]['filterOn']
            var val = state.appliedFilters[f]['value']
            if (!params.hasOwnProperty(key)) {
                params[key] = val
            } else {
                params[key] = params[key] + ',' + val
            }
        }

        //add route
        params['route'] = route

        //do it
        await api.get('jobs', {params}).then(async (response) => {
            await commit(VUEX_JOBS_GET_SUCCESS, response.data)
        }).catch((err) => {
            commit(VUEX_JOBS_GET_FAILURE, err)
        })
    },
    [VUEX_JOBS_GET_REQUEST_FOR_EXCEL]: async ({state, commit, dispatch}, extraParams) => {
        let route = router.currentRoute.name
        let isJobsApproved = (route === 'tools-routing') ? true : state.jobsApproved
        const filteredParams = omit(extraParams || {}, ['shouldPersistJobs', 'filter'])
        let params = Object.assign(
            {
                isJob: isJobsApproved,
                page: 0,
                per_page: 999999999999,
            },
            filteredParams
        )
        if (state.pagination && state.pagination.sortBy) {
            params['sort'] = state.pagination.descending ? '-' + state.pagination.sortBy : state.pagination.sortBy
        }

        //explicity add the icon for routing
        if (route === 'tools-routing') {
            params['include'] = 'avatar'
        }

        //set archived if not set
        var archivedSet = false
        for (var f in state.appliedFilters) {
            if (state.appliedFilters[f].filterOn === 'archived') {
                archivedSet = true
                break
            }
        }
        if (archivedSet === false) {
            let newFilterItem = {}
            newFilterItem.filterOn = 'archived'
            newFilterItem.value = 'active'
            await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)
        }


        //loop through applied filters and turn to params
        for (var f in state.appliedFilters) {
            var key = state.appliedFilters[f]['filterOn']
            var val = state.appliedFilters[f]['value']
            if (!params.hasOwnProperty(key)) {
                params[key] = val
            } else {
                params[key] = params[key] + ',' + val
            }
        }

        //add route
        params['route'] = route


        //do it
        await api.get('jobs', {params}).then(async (response) => {
            exportToExcel.finish(response.data)
        }).catch((err) => {
            exportToExcel.fail(err)
        })
    },
    [VUEX_JOBS_APPLY_DEEPSTATE]: ({commit, dispatch}, dsobj) => {
        commit(VUEX_JOBS_APPLY_DEEPSTATE, dsobj)
        dispatch(VUEX_JOBS_GET_REQUEST, {})
    },


    [VUEX_JOBS_CLEAR_FILTERS]: async ({commit}) => {
        await commit(VUEX_JOBS_CLEAR_FILTERS)
    },

    [VUEX_JOBS_RESET_FILTERS]: async ({commit}) => {
        await commit(VUEX_JOBS_RESET_FILTERS)
    },

    [VUEX_JOBS_APPLY_FILTERS]: async ({commit, dispatch}, filterItem) => {
        await commit(VUEX_JOBS_APPLY_FILTERS, filterItem)
        await dispatch(VUEX_JOBS_GET_REQUEST)
    },
    [VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY]: async ({commit, dispatch}, filterItem) => {
        await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, filterItem)
        await dispatch(VUEX_JOBS_GET_REQUEST)
    },


    [VUEX_JOBS_APPLY_ARCHIVE_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'archived'
        await dispatch(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)
    },

    [VUEX_JOBS_APPLY_STATUS_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'status'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },

    [VUEX_JOBS_APPLY_PROGRESS_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'progress'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_PROGRESS_NOTE_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'progressNote'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },


    [VUEX_JOBS_APPLY_TYPE_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'type'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },

    [VUEX_JOBS_APPLY_DEPARTMENT_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'department'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },

    [VUEX_JOBS_APPLY_DUE_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'due'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },

    [VUEX_JOBS_APPLY_CREATIVE_ROUND_FILTER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'creativeRound'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },


    [VUEX_JOBS_APPLY_USER_REQUESTOR]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userRequestor'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_USER_PROJECT_MANAGER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userProjectManager'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_USER_PRINT_PROJECT_MANAGER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userPrintProjectManager'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_USER_PREMEDIA_PROJECT_MANAGER]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userPremediaProjectManager'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_USER_PREMEDIA_ART_DIRECTOR]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userArtDirector'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },
    [VUEX_JOBS_APPLY_USER_CREATIVE]: async ({dispatch}, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        newFilterItem.filterOn = 'userCreative'
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },


    [VUEX_JOBS_APPLY_USER_ME_IN_ROLE]: async ({ commit, dispatch }) => {
        commit(VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME, "userMeInRole")

        let newFilterItem = {}
        newFilterItem.filterOn = 'userMeInRole'
        newFilterItem.value = 1
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
    },


    [VUEX_JOBS_REMOVE_USER_ME_IN_ROLE]: async ({ commit, dispatch }) => {
        commit(VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME, "userMeInRole")

        let newFilterItem = {}
        newFilterItem.filterOn = 'userMeInRole'
        newFilterItem.value = ''
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

    },

    [VUEX_JOBS_REMOVE_USER_ALL_REQUESTS_MY_DRAFTS]: async ({ commit, dispatch }) => {
        commit(VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME, "userAllRequestsMyDrafts")

        let newFilterItem = {}
        newFilterItem.filterOn = 'userAllRequestsMyDrafts'
        newFilterItem.value = ''
        await dispatch(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

    },

    [VUEX_JOBS_APPLY_FILTER_BY_NAME]: async ({ commit }, filterItem) => {
        let newFilterItem = Object.assign(filterItem)
        commit(VUEX_JOBS_APPLY_FILTER_BY_NAME, newFilterItem)
    },


    [VUEX_JOBS_SYNC_PAGINATION]: ({state, commit, dispatch}, pagination) => {
        //
        // TODO: BL
        // This is a hack to get around the fact that the set/get on the jobs grid calls this on
        // its load b/c the vuetify table changes pagination when it gets mounted (defaults to
        // sort by first sortable column in header). I could block it on the grid component, but
        // it seems illogical to keep syncing pagination if there's no jobs anyway.
        //
        if (state.jobsLoaded === false) {
            return
        }

        //kill quick filter display because then clicked
        dispatch(VUEX_JOBS_SET_FILTER_TOGGLER, {value: "manual"})

        commit(VUEX_JOBS_SYNC_PAGINATION, pagination)
        dispatch(VUEX_JOBS_GET_REQUEST)
    },


    [VUEX_JOBS_APPLY_QUICK_FILTER]: async ({getters, commit, dispatch}, quickFilterConfig) => {
        let extraParams = {}
        let newFilterItem = {}

        let currentUser = getters.getCurrentUser
        let userMeInRoleObject = getters.getUserMeInRoleObject;
        switch (quickFilterConfig.value) {
            case 1:
                //ACTIVE
                //Status: Active
                //Role: Me
                //Default for all users except print approvers)
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_ACTIVE //active
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)


                break;
            case 2:
                //PENDING
                //Status: Approved (does not yet have job number)
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_APPROVED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;
            case 3:
                //In Production
                //Status: Active
                // Role: Me
                // Progress: In Production (default for print approvers)
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_ACTIVE
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'progress'
                newFilterItem.value = SILA_JOB_PROGRESS_IN_PRODUCTION
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;
            case 4:
                //In Design
                //Status: Active
                // Role: Me
                // Progress:  In Design + Revisions
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_ACTIVE
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'progress'
                newFilterItem.value = SILA_JOB_PROGRESS_IN_DESIGN
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'progress'
                newFilterItem.value = SILA_JOB_PROGRESS_REVISIONS
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;
            case 5:
                //In Design
                //Status: Active
                // Role: Me
                //Due by: Today
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_ACTIVE
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'due'
                newFilterItem.value = 'today'
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;

            case 10:
                //Comps
                //Status: Active
                //Role: Me
                //Progress: Comps
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_ACTIVE
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'progress'
                newFilterItem.value = SILA_JOB_PROGRESS_COMPS
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)
                break;

            case 6:
                //In Design
                //Status: Active
                //Role: Me
                //Due by: late
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = 9 //active
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = userMeInRoleObject.filterOn
                newFilterItem.value = userMeInRoleObject.value
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'due'
                newFilterItem.value = 'late'
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;


            ////////////////

            case 7:
                //Pending Approval
                //Status: Executive Review + Resubmit   (default for: exec)
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_EXECUTIVE_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_EXECUTIVE_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)


                break;

            case 8:
                //Pending Print Approval
                //Status: Print Review + Resubmit Print Review
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PRINT_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PRINT_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;

            case 9:
                //All My Requests
                //Requestor: Me (default for all other roles)
                newFilterItem = {}
                newFilterItem.filterOn = 'userRequestor'
                newFilterItem.value = currentUser.id
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;

            case 11:
                //All Requests
                //Show everything for request status
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_DRAFT
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PRINT_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PRINT_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PRINT_NOT_APPROVED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PACKAGE_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PACKAGE_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PACKAGE_NOT_APPROVED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_EXECUTIVE_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_EXECUTIVE_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_EXECUTIVE_NOT_APPROVED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;

            case 12:
                //Pending Package Approval
                //Status: Package Review + Resubmit Package Review
                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PACKAGE_REVIEW
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                newFilterItem = {}
                newFilterItem.filterOn = 'status'
                newFilterItem.value = SILA_JOB_STATUS_PACKAGE_RESUBMITTED
                await commit(VUEX_JOBS_APPLY_FILTERS, newFilterItem)

                break;

        }

        // Set our sorting
        let sortPayload = {
            sortBy:quickFilterConfig.sort,
            descending:false
        }
        await commit(VUEX_JOBS_SYNC_PAGINATION_SORT, sortPayload)

        // commit this quick filter to memory
        await commit(VUEX_JOBS_STORE_QUICK_FILTER, quickFilterConfig)

        // Go go go!!!
        await dispatch(VUEX_JOBS_GET_REQUEST, extraParams)
    },

    [VUEX_JOBS_TEXT_FILTER_SEARCH]: async ({getters, commit, dispatch, state}, payload) => {
        let newFilterItem = {}

        //clear everything
        await dispatch(VUEX_JOBS_CLEAR_FILTERS)

        //kill user me in role
        newFilterItem = {}
        newFilterItem.filterOn = 'userMeInRole'
        newFilterItem.value = ''
        await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)

        //set search terms
        newFilterItem = {}
        newFilterItem.filterOn = 'searchTerms'
        newFilterItem.value = payload.searchTerms
        await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)

        //set the global archive value to this
        newFilterItem = {}
        newFilterItem.filterOn = 'archived'
        newFilterItem.value = payload.includeArchive
        await commit(VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY, newFilterItem)

        // sort by name ASC
        let sortPayload = {
            sortBy:'updated_at',
            descending:true
        }
        await commit(VUEX_JOBS_SYNC_PAGINATION_SORT, sortPayload)

        //kill quick filter display because then clicked
        dispatch(VUEX_JOBS_SET_FILTER_TOGGLER, {value: "manual"})

        // Go go go!!!
        await dispatch(VUEX_JOBS_GET_REQUEST)
    },
    [VUEX_JOBS_CLEAR_TEXT_FILTER_SEARCH]: async ({commit}) => {
        await commit(VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME, 'searchTerms')
    },


    [VUEX_JOBS_SET_PAGINATION_PER_PAGE]: async ({commit}) => {
        await commit(VUEX_JOBS_SET_PAGINATION_PER_PAGE)
    },

    [VUEX_JOBS_GET_PROGRESSES_REQUEST]: async ({commit, dispatch, rootState}, extraParams) => {
        async function applyJobsFilter() {
            // 1) Clear all existing filters
            await dispatch(VUEX_JOBS_CLEAR_FILTERS)

            // 2) Explicitly set pagination
            await commit(VUEX_JOBS_SET_PAGINATION_PER_PAGE, 100)

            // 3) Explicitly set filters (QF was for another purpose)
            await commit(VUEX_JOBS_APPLY_FILTERS, {filter: {'progress': VUEX_UI_PROGRESS_COLUMNS}})


            let extraParams = Object.assign(
                {
                    userMeInRole: 1,
                    status: SILA_JOB_STATUS_ACTIVE + "," + SILA_JOB_STATUS_APPROVED,        //active & aproved
                    include:'roles,avatar',
                    page: 1,
                    per_page: 9999
                },
                extraParams
            )

            // 4) Get the results!
            await dispatch(VUEX_JOBS_GET_REQUEST, extraParams)

        }

        if (rootState.properties.isInitialized === false) {
            const unwatch = store.watch(state => rootState.properties.isInitialized, async (isEnumInitialized) => {
                if (isEnumInitialized) {
                    await applyJobsFilter()
                    unwatch()
                }
            })
        } else {
            await applyJobsFilter()
        }
    },

    /**
     * Get job -> get comments -> get files
     * Params :
     job id
     */
    [VUEX_JOB_GET_REQUEST]: async({state, dispatch, commit}, payload) => {
        // redundant cancels - clear them anyway if still pending - they are also cleared in each individual dispatch
        if (state.cancels.cancelCommentRequest) {
            state.cancels.cancelCommentRequest.cancel()
            commit(VUEX_JOBS_SET_CANCEL,{
                key:'cancelCommentRequest',
                value:null
            })
        }
        if (state.cancels.cancelAttachmentsRequest) {
            state.cancels.cancelAttachmentsRequest.cancel()
            commit(VUEX_JOBS_SET_CANCEL,{
                key:'cancelAttachmentsRequest',
                value:null
            })
        }
        if (state.cancels.cancelWatchesRequest) {
            state.cancels.cancelWatchesRequest.cancel()
            commit(VUEX_JOBS_SET_CANCEL,{
                key:'cancelWatchesRequest',
                value:null
            })
        }


        commit(VUEX_JOB_GET_REQUEST, payload)
        dispatch(VUEX_PREMEDIA_CLEAR_DATA)

        //see if this is a job or request - important for base level considerations
        let route = router.currentRoute.name
        let isJobsApproved = (route === 'tools-routing') ? true : state.jobsApproved
        let getString = `jobs/${payload.id}?include=team,avatar,premedia&isJob=${isJobsApproved}`

        return api.get(getString).then(async response => {
            // TODO: This should ABSOLUTELY be refactored
            commit(VUEX_JOB_GET_SUCCESS, response.data)
            if (payload.includeJobMeta) {
                Promise.all([
                    dispatch(VUEX_JOB_GET_COMMENTS),
                    dispatch(VUEX_JOB_GET_ATTACHMENTS)
                ])
            }
            return response
        }).catch(err => {
            console.error(err)
        })
    },

    [VUEX_JOB_PRINT_GET_REQUEST]: async ({state, commit}, payload) => {
        let getString = `/jobs/${state.job.id}?include=${payload}&download=1`
        await api.get(getString).then(async (response) => {
            await commit(VUEX_JOB_PRINT_GET_REQUEST_SUCCESS, response)
        }).catch(err => {
            console.error(err)
        })
    },

    [VUEX_JOB_DELETE]: async ({state, dispatch, commit}, payload) => {
        await api.delete(`/jobs/${state.job.id}`).then(async (response) => {
            await commit(VUEX_JOB_DELETE, response.data)
            await dispatch(VUEX_JOBS_GET_REQUEST)
            await dispatch(VUEX_JOB_CREATE_CANCEL)
            if (payload.fromJobHeaderDropdown) {
                router.push({name: 'jobs-manage'})
            }
        }).catch((err) => {
            console.error(err)
        })
    },

    /**
     * Update the current job's properties
     * @function
     */
    [VUEX_JOB_UPDATE_REQUEST]: async ({state, dispatch, commit}, payload) => {
        await api.patch(`/jobs/${state.job.id}`, payload).then(async (response) => {
            await commit(VUEX_JOB_UPDATE_REQUEST_SUCCESS, response)
            await dispatch(VUEX_JOB_GET_REQUEST, {id: state.job.id, includeJobMeta: false})
        }).catch((err) => {
            commit(VUEX_JOB_UPDATE_REQUEST_FAILURE, err)
        })
    },

    [VUEX_JOB_UPDATE_DELVIERY_OPTION_REQUEST]: async ({state, dispatch, commit}, payload) => {
        await api.patch(`/jobs/${state.job.id}`, {delivery_options: {...payload}}).then((response) => {
            commit(VUEX_JOB_UPDATE_REQUEST_SUCCESS, response)
            dispatch(VUEX_JOB_GET_REQUEST, {id: state.job.id})
        }).catch((err) => {
            commit(VUEX_JOB_UPDATE_REQUEST_FAILURE, err)
        })
    },

    /**
     * Update the current job's name
     * @function
     */
    [VUEX_JOB_UPDATE_PROP]: async ({dispatch}, params) => {
        await dispatch(VUEX_JOB_UPDATE_REQUEST, params)
    },

    //24 hour toggle is confirmed
    [VUEX_JOB_UPDATE_24HOUR_CONFIRMED]: ({commit}) => {
        commit(VUEX_JOB_UPDATE_24HOUR_CONFIRMED)
    },


    /**
     * Update the current job's name
     * @function
     */
    [VUEX_JOB_UPDATE_DELIVERY_OPTION_PROP]: async ({dispatch}, params) => {
        await dispatch(VUEX_JOB_UPDATE_DELVIERY_OPTION_REQUEST, params)
    },

    /**
     * Get Job comments
     * @function
     */
    [VUEX_JOB_GET_COMMENTS]: async ({state, commit}, payload) => {
        commit(VUEX_JOB_GET_COMMENTS)

        let params = Object.assign({
            page: state.commentPagination.page,
            per_page: state.commentPagination.rowsPerPage,
        }, payload)

        //cancel token
        if (state.cancels.cancelCommentRequest) {
            state.cancels.cancelCommentRequest.cancel()
        }
        commit(VUEX_JOBS_SET_CANCEL,{
            key:'cancelCommentRequest',
            value:axios.CancelToken.source()
        })

        api.get(`/jobs/${state.job.id}/comments?include=avatar`, {
            params: {...params},
            cancelToken: state.cancels.cancelCommentRequest.token
        }).then((response) => {
            commit(VUEX_JOB_GET_COMMENTS_SUCCESS, response.data)
        }).catch((err) => {
            if(axios.isCancel()) {
                commit(VUEX_JOB_GET_COMMENTS_ABORT)
            } else {
                commit(VUEX_JOB_GET_COMMENTS_FAILURE)
            }
        })
    },

    [VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST]: async ({commit, dispatch}, extraParams) => {
        commit(VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST)

        await dispatch(VUEX_JOB_GET_COMMENTS, {
            ...extraParams
        })
    },

    [VUEX_JOB_GET_COMMENT]:({commit}, payload) => {
        api.get(`/jobs/${state.job.id}/comments/${payload}`).then((response) => {
            commit(VUEX_JOB_GET_COMMENT_SUCCESS, response.data.data)
        })
    },

    /**
     * Add Job comment
     */
    [VUEX_JOB_ADD_COMMENT]: async ({commit}, payload) => {
        await api.post(`/jobs/${state.job.id}/comments`, payload).then((response) => {

        })
    },

    /**
     * Add a pending comment
     * This is used for a placeholder to atatch files to prior to comment save
     */
    [VUEX_JOB_ADD_UNPUBLISHED_COMMENT]: async ({commit}, payload) => {
        await api.post(`/jobs/${payload.job_id}/comments`, payload).then((response) => {
            commit(VUEX_JOB_ADD_UNPUBLISHED_COMMENT_SUCCESS, response)
        })
    },

    /**
     * Update Job comment
     * @function
     */
    [VUEX_JOB_UPDATE_COMMENT]: async ({state, commit, dispatch}, payload) => {
        commit(VUEX_JOB_UPDATE_COMMENT)
        let jobId = (payload.jobId) ? payload.jobId : state.job.id //grab from payload, prevents state delay issues with comments with big files
        await api.patch(`/jobs/${jobId}/comments/${payload.id}`, payload.data).then((response) => {
            let index = state.jobComments.findIndex(item => item.id === payload.id)
            if (index === -1) {
                // dispatch(VUEX_JOB_GET_COMMENTS)
                commit(VUEX_JOB_ADD_COMMENT_SUCCESS, response.data.data)
            } else {
                commit(VUEX_JOB_UPDATE_COMMENT_SUCCESS, {
                    id: payload.id,
                    prop: payload.prop,
                    data: response.data.data
                })
            }
        })
    },


    [VUEX_JOB_LIKE_COMMENT]: async ({state, commit, dispatch}, payload) => {
        await api.post(`/jobs/${state.job.id}/comments/${payload.id}/likes`).then((response) => {
            let index = state.jobComments.findIndex(item => item.id == payload.id)
            if (index === -1) {
                dispatch(VUEX_JOB_GET_COMMENTS)
            } else {
                commit(VUEX_JOB_UPDATE_COMMENT_SUCCESS, {
                    id: payload.id,
                    prop: payload.prop,
                    data: response.data.data
                })
            }
        })
    },

    [VUEX_JOB_UNLIKE_COMMENT]: async ({state, commit, dispatch}, payload) => {
        await api.delete(`/jobs/${state.job.id}/comments/${payload.id}/likes`).then((response) => {
            let index = state.jobComments.findIndex(item => item.id == payload.id)
            if (index === -1) {
                dispatch(VUEX_JOB_GET_COMMENTS)
            } else {
                commit(VUEX_JOB_UPDATE_COMMENT_SUCCESS, {
                    id: payload.id,
                    prop: payload.prop,
                    data: response.data.data
                })
            }
        })
    },


    /**
     * Remove Job comment
     * @function
     */
    [VUEX_JOB_REMOVE_COMMENT]: async ({commit, dispatch}, payload) => {
        await api.delete(`/jobs/${state.job.id}/comments/${payload.id}`).then(() => {
            dispatch(VUEX_JOB_GET_ATTACHMENTS) //update attachments (aka the files tab)
            commit(VUEX_JOB_REMOVE_COMMENT_SUCCESS, payload)
        })
    },

    /**
     * Get Job files
     * @function
     */
    [VUEX_JOB_GET_FILES]: async ({commit}) => {
        await api.get(`/jobs/${state.job.id}/files`).then((response) => {
            commit(VUEX_JOB_GET_FILES_SUCCESS, response.data)
        })
    },

    /**
     * Get Job watches
     * @function
     */
    [VUEX_JOB_GET_WATCHES]: async ({commit}) => {
        //cancel token
        if (state.cancels.cancelWatchesRequest) {
            state.cancels.cancelWatchesRequest.cancel()
        }
        commit(VUEX_JOBS_SET_CANCEL,{
            key:'cancelWatchesRequest',
            value:axios.CancelToken.source()
        })

        await api.get(`/jobs/${state.job.id}/watches`,{
            cancelToken: state.cancels.cancelWatchesRequest.token
        }).then((response) => {
            commit(VUEX_JOB_GET_WATCHES_SUCCESS, response.data)
        })
    },

    /**
     * Get job team
     * @function
     */
    [VUEX_JOB_GET_TEAM]: ({commit, dispatch},) => {
        api.get(`/jobs/${state.job.id}/team?include=avatar`).then((response) => {
            commit(VUEX_JOB_GET_TEAM, response.data.data)

            Promise.all([
                dispatch(VUEX_JOB_GET_WATCHES)
            ])
        })
    },

    /**
     * Add Job team member
     * @function
     */
    [VUEX_JOB_TEAM_ADD_MEMBER]: async ({state, dispatch, commit}, payload) => {
        await api.post(`/jobs/${state.job.id}/team?include=avatar`, payload).then(async (response) => {
            await commit(VUEX_JOB_TEAM_ADD_MEMBER_SUCCESS, response.data.data)
            // dispatch(VUEX_JOB_GET_TEAM)

            //update the entire job if this transition state = SILA_JOB_STATE_EXEC_APPROVED
            //this is so the status can refrehs up top
            if (state.job.state === SILA_JOB_STATE_EXEC_APPROVED) {
                await dispatch(VUEX_JOB_GET_REQUEST, {id: state.job.id, includeJobMeta: false})
            }
        }).catch((err) => {
            commit(VUEX_JOB_TEAM_ADD_MEMBER_FAILURE)
        })
    },

    /**
     * Add Job team member
     * @function
     */
    [VUEX_JOB_TEAM_REMOVE_MEMBER]: async ({dispatch, commit}, payload) => {
        await api.delete(`/jobs/${state.job.id}/team`, {data: {...payload}}).then(async (response) => {
            await commit(VUEX_JOB_TEAM_REMOVE_MEMBER_SUCCESS, payload)
            // dispatch(VUEX_JOB_GET_TEAM)
        }).catch((err) => {
            commit(VUEX_JOB_TEAM_REMOVE_MEMBER_FAILURE)
        })
    },

    [VUEX_JOB_WATCH]: async ({commit}, payload) => {
        await api.post(`/jobs/${payload}/watches`, payload.data).then((response) => {
            commit(VUEX_JOB_WATCH_SUCCESS, response.data.data)
        })
    },

    [VUEX_JOB_UNWATCH]: async ({commit}, payload) => {
        await api.delete(`/jobs/${payload}/watches`).then((response) => {
            commit(VUEX_JOB_UNWATCH_SUCCESS, payload)
        })
    },

    [VUEX_JOB_FLAG]: async ({commit, dispatch}, payload) => {
        await api.post(`/jobs/${payload.id}/flags`, {flag: payload.data.value}).then((response) => {
            dispatch(VUEX_AUTH_REFRESH_FROM_TOKEN)
        })
    },

    [VUEX_JOB_UNFLAG]: async ({commit}, payload) => {
        await api.delete(`/jobs/${payload}/flags`).then((response) => {
            commit(VUEX_JOB_UNFLAG_SUCCESS, payload)
        })
    },


    /**
     * Init Create Job Request Component
     * @function
     */
    [VUEX_JOB_CREATE_INIT]: async ({commit, dispatch}) => {
        if (state.cancels.cancelAttachmentsRequest) {
            state.cancels.cancelAttachmentsRequest.cancel()
            await commit(VUEX_JOBS_SET_CANCEL,{
                key:'cancelAttachmentsRequest',
                value:null
            })
        }
        await commit(VUEX_JOB_CREATE_APPLY_TEMPLATE)
        await dispatch(VUEX_PREMEDIA_CLEAR_DATA) // clear premedia rows
        await commit(VUEX_JOB_CREATE_INIT)
        await commit(VUEX_JOB_CREATE_UI)
    },
    [VUEX_JOB_CREATE_INIT_MILESTONES_DONE]: ({commit, dispatch}) => {
        if (state.didMileStoneDoneOnce == false) {
            //GLOBAL ACTION PROMPT: Pass array of optional states to watch
            var stateChangeWatchers = [
                ['jobs', 'createJob_PropsToUpdate']
            ]
            dispatch('VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS', {stateChangeWatchers: stateChangeWatchers})

            commit(VUEX_JOB_CREATE_INIT_MILESTONES_DONE)
        }
    },

    /**
     * Create Job Request
     * @function
     */
    [VUEX_JOB_CREATE]: debounce(async ({state, dispatch, commit}) => {
        await commit(VUEX_JOB_CREATE)
        api.post(`/jobs`, state.createJob_PropsToUpdate).then(async (response) => {
            await commit(VUEX_JOB_CREATE_SUCCESS, response.data.data)
            await commit(VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE)
            dispatch(VUEX_JOBS_GET_REQUEST)
        }).catch((err) => {
            commit(VUEX_JOB_CREATE_FAILURE)
            console.error(err)
        })
    }, 1200),

    /**
     * Load Job Request Draft
     * @function
     */
    [VUEX_JOB_CREATE_LOAD]: async ({state, dispatch, commit}, payload) => {
        await dispatch(VUEX_JOB_GET_REQUEST, payload)

        // TODO: Consolidate into Promise.all?
        await dispatch(VUEX_JOB_GET_ATTACHMENTS)
        await dispatch(VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS)

        //fromPremediaRow - from premedia
        if (payload && payload.hasOwnProperty('fromPremediaRow') && payload.fromPremediaRow) {

        } else {
            //do new job create
            await commit(VUEX_JOB_CREATE_LOAD)
            await commit(VUEX_JOB_CREATE_CANCEL_PROMPT, false)
            commit(VUEX_JOB_CREATE_UI)
        }

    },

    [VUEX_JOB_CREATE_UPDATE]: async ({state, dispatch, commit}, payload) => {
        await commit(VUEX_JOB_CREATE_UPDATE)

        // Some trickery needed to move 24Hr Rush to priority radio group on Job create
        let data = Object.assign(state.createJob_PropsToUpdate)
        if (data.hasOwnProperty('is_24_hour_rush') && data.is_24_hour_rush == null) delete data.is_24_hour_rush
        if (data.is_24_hour_rush) delete data.priority

        //set archived here also if this is an isarchive request (occurs as an option during create)
        if (payload == 'isarchive') {
            data.is_archived = 1 //not sure if data is even being used, but setting it to line up with logic above
            state.createJob_PropsToUpdate.is_archived = 1
        }

        if (state.createJob_Data.type !== SILA_JOB_TYPE_PACKAGING) {
            commit(VUEX_JOB_CREATE_UPDATE_PROP, {job_number:null})
        }

        await api.patch(`/jobs/${state.createJob_Data.id}`, state.createJob_PropsToUpdate).then(async (response) => {
            await dispatch(VUEX_JOBS_GET_REQUEST)
            await commit(VUEX_JOB_CREATE_UPDATE_SUCCESS, response.data.data)
            commit(VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE)

            // SHOW SNACKBAR
            var route = router.currentRoute.name
            var temp_button_text = "View All Requests"
            var temp_description_text = "Success! Your request has been submitted."
            var temp_button_dispatch = "VUEX_ROUTING_PUSH_ROUTE_NAME"
            var temp_button_dispatch_payload = 'jobs-requests'
            var temp_timeout = 4000

            //request overrides
            if (route === 'jobs-requests')  {
                temp_button_text = ""
                temp_button_dispatch = ""
                temp_button_dispatch_payload = {}
                temp_timeout = 6000
            }

            //draft overrides
            if (payload == 'isdraft') {
                temp_description_text = "Success! Your draft has been saved."
            } else if (payload == 'isarchive') {
                temp_description_text = "Success! Your request has been archived."
            }

            dispatch(VUEX_SNACKBAR_SHOW, {
                description_text: temp_description_text,
                button_text: temp_button_text,
                timeout: temp_timeout,
                button_dispatch: temp_button_dispatch,
                button_dispatch_payload: temp_button_dispatch_payload,
            })



            //APPCUES
            window.Appcues.track("Requested Job");


            //now let's close out drafts overlay
            if (payload == 'isdraft' || payload == 'isarchive') {
                if (route === 'jobs-requests')  {
                    //refresh drafts view, since a new draft has been added
                    dispatch(VUEX_JOBS_GET_REQUEST)
                }
                //and close!
                dispatch(VUEX_JOB_CREATE_CANCEL)
            }

        }).catch((err) => {
            commit(VUEX_JOB_CREATE_UPDATE_FAILURE)
            console.error(err)
        })
    },

    [VUEX_JOB_CREATE_HAS_CHANGED]: ({state, commit}) => {
        if (!isEmpty(state.createJob_PropsToUpdate)) {
            commit(VUEX_JOB_CREATE_HAS_CHANGED, true)
        } else {
            commit(VUEX_JOB_CREATE_HAS_CHANGED, false)
        }
    },

    [VUEX_JOB_CREATE_CANCEL]: async ({state, commit, dispatch}) => {
        await commit(VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE)
        await commit(VUEX_JOB_CREATE_CANCEL_PROMPT, false)

        //reset
        await commit(VUEX_JOB_CREATE_APPLY_TEMPLATE)
        await dispatch(VUEX_PREMEDIA_CLEAR_DATA) // clear premedia rows

        commit(VUEX_JOB_CREATE_CANCEL)
    },

    [VUEX_JOB_CREATE_UPDATE_PROP]: async ({commit, dispatch}, payload) => {
        await commit(VUEX_JOB_CREATE_UPDATE_PROP, payload)
        await dispatch(VUEX_JOB_CREATE_HAS_CHANGED)

        if (!state.createJob_IsSaved &&
            state.createJob_PropsToUpdate.name &&
            state.createJob_PropsToUpdate.department &&
            state.createJob_PropsToUpdate.type) {

            dispatch(VUEX_JOB_CREATE)
        }
    },

    [VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP]: async ({commit, dispatch}, payload) => {
        await commit(VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP, payload)
        dispatch(VUEX_JOB_CREATE_HAS_CHANGED)
    },

    [VUEX_JOB_TRANSITION]: async ({state, dispatch, commit}, payload) => {
        switch (payload.transition) {
            case 'submit_for_print_approval' :
            case 'resubmit_for_print_approval' :

            case 'submit_for_package_approval' :
            case 'resubmit_for_package_approval' :

            case 'submit_for_exec_approval' :
            case 'resubmit_for_exec_approval' :
                if (!isEmpty(state.createJob_PropsToUpdate))
                    await dispatch(VUEX_JOB_CREATE_UPDATE)
                break
        }
        const patchData = { transition: payload.transition }
        if (payload.transitionComment) patchData.transition_comment = payload.transitionComment

        await api.patch(`jobs/${payload.id}`, patchData).then(async (response) => {
            await commit(VUEX_JOB_TRANSITION_SUCCESS, response.data) // commit sate on success
            await dispatch(VUEX_JOB_TRANSITION_SUCCESS, payload) // run logic on success

            await dispatch(VUEX_JOBS_GET_REQUEST) //TODO: remove call to get all jobs and only refresh the one transitioned"

        }).catch((err) => {
            console.error(err)
        })
    },

    [VUEX_JOB_TRANSITION_SUCCESS]: async ({dispatch, commit}, payload) => {
        switch (payload.transition) {
            // For (re)submission of draft
            case 'submit_for_print_approval' :
            case 'resubmit_for_print_approval' :

            case 'submit_for_package_approval' :
            case 'resubmit_for_package_approval' :

            case 'submit_for_exec_approval' :
            case 'resubmit_for_exec_approval' :
                await commit(VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE)
                await dispatch(VUEX_JOB_CREATE_CANCEL)
                break


            ////
            case 'print_approve' :
            case 'reject_print_approval' :

            case 'package_approve' :
            case 'reject_package_approval' :

            case 'exec_approve' :
            case 'reject_exec_approval' :
                // This now moves to the stream tab instead of
                //if('job-requests')
                //await dispatch(VUEX_UI_HIDE_RIGHT_DRAWER)
                break
        }
    },


    /**
     * THIS FILTER TOGGLER IS USED TO SYNC UP BUTTON DISPLAY STATES
     */
    [VUEX_JOBS_SET_FILTER_TOGGLER]: ({commit, state}, obj) => {
        //var oldValue = state.filterToggler
        var newValue = obj.value

        // always randomize quick so it refreshes
        if (newValue !== 'manual') {
            newValue = 'quick' + Date.now()
        }

        //clear out the quick filter in storage
        if (newValue === 'manual') {
            commit(VUEX_JOBS_STORE_QUICK_FILTER, {})
        }

        //trigger the mutator
        commit(VUEX_JOBS_SET_FILTER_TOGGLER, newValue)
    },


    [VUEX_JOBS_SET_APPROVED]: ({commit, state}, obj) => {
        var newValue = obj.value
        commit(VUEX_JOBS_SET_APPROVED, newValue)
    },


    // SEARCH
    [VUEX_JOB_UPDATE_SEARCH_TERM]: async ({commit, dispatch}, payload) => {
        if (!payload) return
        dispatch(VUEX_JOB_GET_SEARCH, payload)
        commit(VUEX_JOB_GET_SEARCH,payload)
    },
    [VUEX_JOB_GET_SEARCH]: async ({commit, dispatch}, payload) => {
        let params = {
            'q': payload.q,
            'includeArchive': payload.includeArchive
        }

        await api.get(`/jobs-search/`, {params}).then(async (response) => {
            commit(VUEX_JOB_GET_SEARCH_SUCCESS, response)
        })
    },
    [VUEX_JOB_CLEAR_SEARCH_DATA]: async ({commit, dispatch}, payload) => {
        commit(VUEX_JOB_CLEAR_SEARCH_DATA)
    },


    /**
     * File Attachment
     */
    // TODO: Come back and, you know, make this do the right thing
    [VUEX_JOB_ATTACH_FILE]: async ({dispatch}, payload) => {
        api.post(`/attachments`, {
            file_id: payload.id,
            model_id: payload.attach_to.model_id,
            model: payload.attach_to.model,
            note: payload.note || null,
        }).then(async (response) => {
            dispatch(VUEX_JOB_GET_ATTACHMENTS, payload.job_id)
        }).catch((err) => {
            console.error(err)
        })
    },

    // TODO: Come back and, you know, make this do the right thing
    [VUEX_JOB_COMMENT_ATTACH_FILE]: async ({dispatch}, payload) => {
        api.post(`/attachments`, {
            file_id: payload.id,
            model_id: payload.attach_to.model_id,
            model: payload.attach_to.model,
            note: payload.note || null,
        }).then(async () => {
            dispatch(VUEX_JOB_GET_ATTACHMENTS, payload.job_id)
        }).catch((err) => {
            console.error(err)
        })
    },

    [VUEX_JOB_GET_ATTACHMENTS]: async ({commit, state}, payload) => {
        //cancel token
        if (state.cancels.cancelAttachmentsRequest) {
            state.cancels.cancelAttachmentsRequest.cancel()
        }
        commit(VUEX_JOBS_SET_CANCEL,{
            key:'cancelAttachmentsRequest',
            value:axios.CancelToken.source()
        })

        let jobId = payload ? payload : state.job.id // Specific request, or general on load
        api.get(`/jobs/${jobId}/attachments`,{
            cancelToken: state.cancels.cancelAttachmentsRequest.token
        }).then(async (response) => {
            await commit('VUEX_JOB_GET_ATTACHMENTS_SUCCESS', response)
        }).catch((err) => {
            console.error('VUEX_JOB_GET_ATTACHMENTS ERROR',err)
        })
    },

    [VUEX_JOB_REMOVE_FILE]: async ({dispatch, commit}, payload) => {
        await dispatch(VUEX_ATTACHMENTS_DELETE_ATTACHMENT, payload).then((response) => {
            if (!response.status) return
            if (response.status == 200 || response.status == 204)
                commit(VUEX_JOB_REMOVE_FILE_SUCCESS, payload)
        })
    },

    [VUEX_JOB_COMMENT_REMOVE_FILE]: async ({dispatch, commit}, payload) => {
        await dispatch(VUEX_ATTACHMENTS_DELETE_ATTACHMENT, payload).then((response) => {
            if (!response.status) return
            if (response.status == 200 || response.status == 204)
                commit(VUEX_JOB_COMMENT_REMOVE_FILE_SUCCESS, payload)
            dispatch(VUEX_JOB_GET_ATTACHMENTS)
        })
    },

    [VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM]: async ({commit}, payload) => {
        commit(VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM, payload)
    },



    /**
     * Get a print of a job
     */
    [VUEX_JOB_GENERATE_PRINT_PDF]: ({state, dispatch}, payload) => {
        let jobId = payload.jobId ? payload.jobId : state.job.id // Specific request, or general on load
        let options = payload.options || ['overview', 'details', 'premedia', 'team', 'stream', 'files'].join(",")

        api.get('/jobs/' + jobId + '/pdf?include=' + options).then((response) => {

            var url = process.env.VUE_APP_API_BASE_URL + "/pdf/" + response.data.fn + "/" + response.data.jn;
            var newWin = window.open(url,'_blank')
            if(!newWin || newWin.closed || typeof newWin.closed=='undefined') {
                //Show snackbar for success
                dispatch(VUEX_SNACKBAR_SHOW, {
                    description_text: "Blocked!  Please disable your popup blockers to see this PDF",
                    button_text: "",
                    timeout: 4000,
                    button_dispatch: "",
                    button_dispatch_payload: {},
                })
            }
            dispatch(VUEX_UI_HIDE_JOB_PRINT_OVERLAY)

        }).catch((err) => {
            dispatch(VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY, 'An unknown error has occured.')
        })

    },
}


/**
 * Jobs module mutation definitions
 * @const
 */
const mutations = {

    [VUEX_JOBS_GET_REQUEST]: (state, extraParams) => {
        const params = Object.assign({shouldPersistJobs: false}, extraParams)

        if (params.shouldPersistJobs === false) {
            state.jobs = []
            state.pagination.totalItems = 0
        }

        state.jobsLoaded = false
    },

    [VUEX_JOBS_GET_SUCCESS]: (state, payload) => {
        state.jobs = payload.data
        state.jobsMeta = payload.meta
        state.jobsLinks = payload.links
        state.jobsLoaded = true
        state.pagination.totalItems = payload.meta.total
        state.pagination.page = payload.meta.current_page
    },

    [VUEX_JOBS_GET_FAILURE]: (state, payload) => {
        console.error((`{${VUEX_JOBS_GET_FAILURE}:payload`))
    },

    //
    // Filtering
    //
    //allows multiple values
    [VUEX_JOBS_APPLY_FILTERS]: (state, filterItem) => {
        let fil = cloneDeep(state.appliedFilters)
        let idx = fil.findIndex(x => x.value === filterItem.value && x.filterOn === filterItem.filterOn)
        if (idx > -1) {
            state.appliedFilters.splice(idx, 1) // remove
        } else {
            state.appliedFilters.push(filterItem) // add
        }
    },
    //like above, but one value only
    [VUEX_JOBS_APPLY_FILTERS_ONE_VALUE_ONLY]: (state, filterItem) => {
        let idx = state.appliedFilters.findIndex(x => x.filterOn === filterItem.filterOn)
        if (idx > -1) {
            state.appliedFilters.splice(idx, 1) // remove
        }
        state.appliedFilters.push(filterItem) // add
    },

    [VUEX_JOBS_CLEAR_FILTERS]: (state) => {
        state.appliedFilters = []
    },

    [VUEX_JOBS_RESET_FILTERS]: (state) => {
        state.appliedFilters = []

    },

    [VUEX_JOBS_SYNC_PAGINATION]: (state, pagination) => {
        state.pagination = pagination
    },

    [VUEX_JOBS_SYNC_PAGINATION_SORT]: (state, payload) => {
        state.pagination.sortBy = payload.sortBy
        state.pagination.descending = payload.descending
    },

    [VUEX_JOBS_SET_APPROVED]: (state, value) => {
        state.jobsApproved = value
    },


    [VUEX_JOBS_SET_PAGINATION_PER_PAGE]: (state, value) => {
        if (value === undefined || value === null) {
            state.pagination.rowsPerPage = state.prevRowsPerPage
        } else {
            state.prevRowsPerPage = state.pagination.rowsPerPage
            state.pagination.rowsPerPage = value
        }
    },

    [VUEX_JOB_GET_REQUEST]: (state, payload) => {
        // state.job = {} //don't do this - causes infinite loop
        state.jobTeam = []
        state.jobLoaded = false

        if (payload.includeJobMeta) {
            state.newJobCommentsRequest = true
            state.commentPagination = {
                lastPage: 1,
                nextPage: null,
                page: 1,
                rowsPerPage: 15,
                totalItems: 0,
            }

            //clear out comments, attachments, and watches, unpublished comments
            state.jobComments = []
            state.jobAttachments = []
            state.jobWatches = []
            state.jobComment_IsSaving = false
            state.jobPendingComment = null
            state.jobPendingCommentText = null
            state.jobPendingCommentHasAttachments = false
        }
    },

    [VUEX_JOB_GET_SUCCESS]: (state, payload) => {
        state.job = payload.data
        state.jobLinks = payload.links
        state.jobLoaded = true

        //we need this - it is used directly in the jobs routing assign person lookups
        if (payload.data.team) {
            state.jobTeam = payload.data.team
        }

        // Change viewed_status when selected
        let match = state.jobs.filter(item => item.id == payload.data.id)
        if (match.length) match[0].viewed_status = true
    },

    [VUEX_JOB_GET_FAILURE]: (state, payload) => {
        console.error(Error(`{${VUEX_JOB_GET_FAILURE}:payload`))
    },

    [VUEX_JOB_DELETE]: (state, payload) => {
        //
    },


    [VUEX_JOB_UPDATE_24HOUR_CONFIRMED]: (state) => {
        state.job24RushCancelConfirmed = true
    },

    [VUEX_JOB_GET_COMMENTS]: (state) => {
        state.commentsLoading = true
    },

    [VUEX_JOB_GET_COMMENTS_SUCCESS]: (state, payload) => {
        state.commentsLoading = false
        state.newJobCommentsRequest = false

        if (state.jobComments.length > 0) {
            let comments = payload.data.filter(el => !state.jobComments.find(f => el.id === f.id));
            Vue.set(state, 'jobComments', state.jobComments.concat(comments))
        } else {
            state.jobComments = payload.data
        }

        if (state.jobCommentsLinks.length > 0) {
            Vue.set(state, 'jobCommentsLinks', state.jobCommentsLinks.concat(payload.links))
        } else {
            state.jobCommentsLinks = payload.links
        }
    },

    [VUEX_JOB_GET_COMMENTS_ABORT]:(state) => {
        state.commentPagination = {
            lastPage: 1,
            nextPage: null,
            page: 1,
            rowsPerPage: 15,
            totalItems: 0,
        }
    },

    [VUEX_JOB_GET_COMMENTS_FAILURE]: (state, payload) => {
        state.commentsLoading = false
    },

    [VUEX_JOB_GET_COMMENTS_NEXT_PAGE_REQUEST]: (state) => {
        state.commentPagination.page = state.commentPagination.page + 1
    },

    [VUEX_JOB_GET_COMMENT_SUCCESS]:(state, payload) => {
        if (state.job.id === payload.job_id) {
            state.jobComments.unshift(payload)
        }

    },

    // Mutation: Add a comment
    [VUEX_JOB_ADD_COMMENT]: (state) => {
        state.jobComment_IsSaving = true
    },

    // Mutation: Add a comment success
    // there is also the chance that the user switched to a different job, so be sure the job ID matches before pushing onto VUE
    [VUEX_JOB_ADD_COMMENT_SUCCESS]: (state, payload) => {
        if (state.job.id === payload.job_id) {
            state.jobComments.unshift(payload)
        }
        state.jobComment_IsSaving = false
    },

    // Mutation: Add a pending comment
    [VUEX_JOB_ADD_UNPUBLISHED_COMMENT]: (state) => {
        state.jobComment_IsSaving = true
    },

    // Mutation: Add a pending comment success
    [VUEX_JOB_ADD_UNPUBLISHED_COMMENT_SUCCESS]: (state, payload) => {
        state.jobPendingComment = payload.data.data
        state.jobComment_IsSaving = false
    },

    // Mutation: Clear pending comment
    [VUEX_JOB_CLEAR_UNPUBLISHED_COMMENT]: (state) => {
        state.jobComment_IsSaving = false
        state.jobPendingComment = null
        state.jobPendingCommentText = null
        state.jobPendingCommentHasAttachments = false
    },

    // Mutation: Used as the storage for the comment text when making a job comment
    //           so we can keep an eye out for it on navigate away
    [VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_TEXT]: (state, payload) => {
        state.jobPendingCommentText = payload
    },

    // Mutation: Used to let us know when a pending comment has attachments
    //           so we can keep an eye out for it on navigate away
    [VUEX_JOB_UPDATE_UNPUBLISHED_COMMENT_SET_HAS_ATTACHMENTS]: (state, payload) => {
        state.jobPendingCommentHasAttachments = payload
    },

    // Mutation: SET Signal flag used to tell the comment drawer to teardown
    [VUEX_JOB_SET_TEARDOWN_COMMENT_FLAG]: (state) => {
        state.jobCommentTeardownFlag = true
    },

    // Mutation: CLEAR Signal flag used to tell the comment drawer to teardown
    [VUEX_JOB_CLEAR_TEARDOWN_COMMENT_FLAG]: (state) => {
        state.jobCommentTeardownFlag = false
    },

    [VUEX_JOB_UPDATE_COMMENT]: (state) => {
        state.jobComment_IsSaving = true
    },

    [VUEX_JOB_UPDATE_COMMENT_SUCCESS]: (state, payload) => {
        if (state.job.id === payload.data.job_id) {
            var index = state.jobComments.findIndex(item => item.id === payload.id)
            state.jobComments[index][payload.prop] = payload.data[payload.prop]
        }
        state.jobComment_IsSaving = false
    },

    [VUEX_JOB_REMOVE_COMMENT_SUCCESS]: (state, payload) => {
        state.jobComments.splice(payload.index, 1)
    },

    [VUEX_JOB_GET_FILES_SUCCESS]: (state, payload) => {
        state.jobFiles = payload.data
    },

    [VUEX_JOB_GET_WATCHES_SUCCESS]: (state, payload) => {
        state.jobWatches = payload.data
    },

    [VUEX_JOB_UPDATE_REQUEST_SUCCESS]: (rootState, payload) => {
        rootState.lastSuccess = payload
    },

    [VUEX_JOB_UPDATE_REQUEST_FAILURE]: (rootState, error) => {
        rootState.lastError = error
    },

    [VUEX_JOB_GET_TEAM]: (state, payload) => {
        state.jobTeam = payload
    },

    [VUEX_JOB_TEAM_ADD_MEMBER]: () => {
        // Do something on 'VUEX_JOB_TEAM_ADD_MEMBER' action
    },

    [VUEX_JOB_TEAM_ADD_MEMBER_SUCCESS]: (state, payload) => {
        state.jobTeam.push(payload)
    },

    [VUEX_JOB_TEAM_ADD_MEMBER_FAILURE]: () => {
        //
    },

    [VUEX_JOB_TEAM_REMOVE_MEMBER]: () => {
        // Do something on 'VUEX_JOB_TEAM_REMOVE_MEMBER' action
    },

    [VUEX_JOB_TEAM_REMOVE_MEMBER_SUCCESS]: (state, payload) => {
        let index = state.jobTeam.findIndex(x => x.user.id === payload.user_id && x.role === payload.role)
        if (index > -1) {
            state.jobTeam.splice(index, 1)
        }
    },

    [VUEX_JOB_TEAM_REMOVE_MEMBER_FAILURE]: () => {
        //
    },

    [VUEX_JOB_CREATE_APPLY_TEMPLATE]: (state) => {
        state.createJob_Data = cloneDeep(createJob_Template)
    },

    [VUEX_JOB_CREATE_INIT]: (state, payload) => {
        state.jobAttachments = []
        state.job = {}
        state.createJob_CancelPrompt = false
        state.didMileStoneDoneOnce = false
        state.createJob_IsSaving = false
        //state.createJob_IsSaved = false
    },
    [VUEX_JOB_CREATE_INIT_MILESTONES_DONE]: (state, payload) => {
        state.didMileStoneDoneOnce = true
    },

    // CREATE JOB
    [VUEX_JOB_CREATE]: (state) => {
        state.createJob_IsSaving = true
    },

    // CREATE JOB - SUCCESS
    [VUEX_JOB_CREATE_SUCCESS]: (state, payload) => {
        state.createJob_Data = cloneDeep(payload)
        state.job = cloneDeep(payload)
        state.createJob_HasChanged = false
        state.createJob_IsSaving = false
        state.createJob_IsSaved = true
    },

    // CREATE JOB - FAILURE
    [VUEX_JOB_CREATE_FAILURE]: (state) => {
        state.createJob_IsSaving = false
        state.createJob_IsSaved = false
    },

    // LOAD DRAFT
    [VUEX_JOB_CREATE_LOAD]: (state) => {
        state.createJob_Data = cloneDeep(state.job)
        state.createJob_IsSaved = true
        state.jobAttachments = []
        state.createJob_CancelPrompt = false
        state.didMileStoneDoneOnce = false
        state.createJob_IsSaving = false
    },

    // UPDATE JOB
    [VUEX_JOB_CREATE_UPDATE]: (state) => {
        state.createJob_IsSaving = true
    },

    [VUEX_JOB_CREATE_UPDATE_SUCCESS]: (state, payload) => {
        state.createJob_Data = cloneDeep(payload)
        state.createJob_IsSaving = false
        state.createJob_HasChanged = false
    },

    [VUEX_JOB_CREATE_UPDATE_FAILURE]: (state) => {
        state.createJob_IsSaving = false
        state.createJob_IsSaved = false
        // TODO: report error
    },

    [VUEX_JOB_CREATE_CLEAR_PROPS_TO_UPDATE]: (state) => {
        var props = Object.getOwnPropertyNames(state.createJob_PropsToUpdate)
        for (var i = 0; i < props.length; i++) {
            delete state.createJob_PropsToUpdate[props[i]]
        }
    },

    //  UPDATE PROP IN STORE
    [VUEX_JOB_CREATE_UPDATE_PROP]: (state, payload) => {
        // TODO: Can this be done better/somewhere else?
        switch (Object.keys(payload)[0]) {

            case 'department' :
                delete state.createJob_PropsToUpdate.international_subdepartment

                if (state.createJob_PropsToUpdate.delivery_options)
                    delete state.createJob_PropsToUpdate.delivery_options.working_files_for_print
                break

            case 'type' :
                delete state.createJob_PropsToUpdate.date_submitted
                delete state.createJob_PropsToUpdate.date_first_comp
                delete state.createJob_PropsToUpdate.date_premedia
                delete state.createJob_PropsToUpdate.date_release
                delete state.createJob_PropsToUpdate.date_delivery
                break

            case 'is_24_hour_rush' :
                if (payload.is_24_hour_rush == false) {
                    state.createJob_PropsToUpdate.priority = 1
                    state.createJob_Data.priority = 1
                    break
                }

                delete state.createJob_PropsToUpdate.date_submitted
                delete state.createJob_PropsToUpdate.date_first_comp
                delete state.createJob_PropsToUpdate.date_premedia
                delete state.createJob_PropsToUpdate.date_release
                delete state.createJob_PropsToUpdate.date_delivery

                //state.createJob_Data.priority = createJob_Template.priority

                delete state.createJob_PropsToUpdate.priority_note
                delete state.createJob_PropsToUpdate.priority_supervisor_name
                delete state.createJob_PropsToUpdate.date_requested_delivery
                delete state.createJob_PropsToUpdate.date_requested_extended_delivery
                delete state.createJob_PropsToUpdate.date_requested_first_comp
                state.createJob_Data.priority_note = createJob_Template.priority_note
                state.createJob_Data.priority_supervisor_name = createJob_Template.priority_supervisor_name
                state.createJob_Data.priority_requested_delivery_date = createJob_Template.date_requested_delivery
                state.createJob_Data.priority_requested_first_comp_date = createJob_Template.date_requested_first_comp
                break

            default :
                break
        }

        let mergedData = Object.assign(state.createJob_Data, payload)
        state.createJob_Data = cloneDeep(mergedData)

        Object.assign(state.createJob_PropsToUpdate, payload)

        //unset this confirmation dialogue
        state.job24RushCancelConfirmed = false

    },

    [VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP]: (state, payload) => {
        if (!state.createJob_PropsToUpdate.delivery_options)
            state.createJob_PropsToUpdate.delivery_options = {}

        // TODO: can this be done better/somewhere else
        switch (Object.keys(payload)[0]) {

            case 'hires_pdf' :
                delete state.createJob_PropsToUpdate.delivery_options.hires_pdf_dielines
                delete state.createJob_PropsToUpdate.delivery_options.hires_pdf_cropmarks
                delete state.createJob_PropsToUpdate.delivery_options.hires_pdf_fullbleed
                delete state.createJob_PropsToUpdate.delivery_options.hires_pdf_slug

            default :
                break
        }

        let mergedData = Object.assign(state.createJob_Data.delivery_options, payload)
        state.createJob_Data.delivery_options = cloneDeep(mergedData)

        Object.assign(state.createJob_PropsToUpdate.delivery_options, payload)
    },

    [VUEX_JOB_CREATE_CLEAR_DELIVERY_OPTIONS]: (state) => {
        if (!state.createJob_PropsToUpdate.delivery_options) return
        var props = Object.getOwnPropertyNames(state.createJob_PropsToUpdate.delivery_options)
        for (var i = 0; i < props.length; i++) {
            delete state.createJob_PropsToUpdate.delivery_options[props[i]]
        }

        state.createJob_Data.delivery_options = {}
    },

    [VUEX_JOB_CREATE_HAS_CHANGED]: (state, payload) => {
        state.createJob_HasChanged = payload
    },

    // CANCEL JOB
    [VUEX_JOB_CREATE_CANCEL]: (state) => {
        state.createJob_IsSaving = false
        state.createJob_IsSaved = false
    },

    [VUEX_JOB_CREATE_CANCEL_PROMPT]: (state, payload) => {
        state.createJob_CancelPrompt = payload
    },

    [VUEX_JOB_TRANSITION]: (state, payload) => {
        state.inTransition = true
    },

    [VUEX_JOB_TRANSITION_SUCCESS]: (state, payload) => {
        state.job = cloneDeep(payload.data)
        state.inTransition = false
    },

    [VUEX_JOB_TRANSITION_FAILURE]: (state, payload) => {
        state.inTransition = false
    },


    //
    // On VUEX_FILE_HANDLE_FILE_NOTIFICATION we use this to surgically replace files
    //
    [VUEX_JOB_REPLACE_FILE_ON_COMMENT_ATTACHMENT]: (state, payload) => {
        try {
            Object.assign(state.jobComments[payload.commentIndex].attachments[payload.attachmentIndex], {file: payload.file})
        } catch (err) {
            console.error(err)
        }
    },

    //
    // On VUEX_FILE_HANDLE_FILE_NOTIFICATION we use this to surgically replace files
    //
    [VUEX_JOB_REPLACE_FILE_ON_JOB_ATTACHMENT]: (state, payload) => {
        try {
            Object.assign(state.jobAttachments[payload.attachmentIndex], {file: payload.file})
        } catch (err) {
            console.error(err)
        }
    },


    //
    // AUTH TEARDOWN
    //
    [VUEX_AUTH_LOGOUT]: (state) => {
        state.jobs = []
        state.jobsLoaded = false

        state.job = {}
        state.jobLoaded = false
    },

    //
    // Teardown comment on enter
    //
    [VUEX_ROUTING_ENTER_JOB]: (state) => {
        state.jobCommentTeardownFlag = false
        state.job24RushCancelConfirmed = false
    },


    //
    // ROUTING TEARDOWN
    //
    [VUEX_JOBS_EXIT_JOBS]: (state, commit) => {
        state.jobs = []
        state.job = {}
        state.appliedFilters = []
        state.jobsLoaded = false
        state.inTransition = false

    },
    [VUEX_JOBS_EXIT_JOB]: (state, commit) => {
        state.job = {}
        state.jobFiles = {}
        state.jobWatches = []
        state.jobLinks = {}
        state.jobComments = []
        state.jobCommentsLinks = []
        state.jobLoaded = false
        state.inTransition = false
        state.job24RushCancelConfirmed = false
    },

    // Sets the watched property that will toggle filter state
    [VUEX_JOBS_SET_FILTER_TOGGLER]: (state, payload) => {
        state.filterToggler = payload
    },

    // stores the current quick filter that is applied
    [VUEX_JOBS_STORE_QUICK_FILTER]: (state, payload) => {
        state.currentQuickFilter = payload
    },


    [VUEX_JOBS_APPLY_FILTER_BY_NAME]: (state, obj) => {
        //TODO
    },

    [VUEX_JOBS_REMOVE_APPLIED_FILTER_BY_NAME]: (state, name) => {
        let idx = state.appliedFilters.findIndex(x => x.filterOn === name)
        if (idx > -1) {
            state.appliedFilters.splice(idx, 1)
        }
    },

    [VUEX_JOBS_APPLY_DEEPSTATE]: (state, payload) => {
        state.currentQuickFilter = payload.currentQuickFilter
        state.appliedFilters = payload.appliedFilters
        state.pagination = payload.pagination
    },


    // SEARCH
    [VUEX_JOB_GET_SEARCH]: (state, payload) => {
        state.searchLoading = true
        state.searchTerm = payload.q
    },

    [VUEX_JOB_GET_SEARCH_SUCCESS]: (state, payload) => {
        state.searchData = payload.data.data
        state.searchLoading = false
    },

    [VUEX_JOB_GET_SEARCH_FAILURE]: (state) => {
        state.searchLoading = false
    },

    [VUEX_JOB_CLEAR_SEARCH_DATA]: (state) => {
        state.searchData = []
        state.searchTerm = null
        state.searchLoading = false
    },

    /**
     * File attachments
     */
    [VUEX_JOB_GET_ATTACHMENTS_SUCCESS]: (state, payload) => {
        state.jobAttachments = payload.data.data

        //clear is_late
        if (state.jobAttachments) {
            for (var i = 0; i < state.jobAttachments.length; i++) {
                if (state.jobAttachments[i].file && state.jobAttachments[i].file.usage_sub_type === SILA_FILE_USAGE_SUB_TYPE__JOB_COMP_1) {
                    state.job.is_late = 0
                }
            }
        }

    },

    [VUEX_JOB_REMOVE_FILE_SUCCESS]: (state, payload) => {
        let fileIndex = state.jobAttachments.findIndex(file => file.file_id === payload.file_id)
        if (fileIndex > -1) {
            state.jobAttachments.splice(fileIndex, 1)
        }
    },

    [VUEX_JOB_COMMENT_REMOVE_FILE_SUCCESS]: (state, payload) => {
        let commentIndex = state.jobComments.findIndex(comment => comment.id === payload.model_id)

        if (commentIndex == -1) return

        let fileIndex = state.jobComments[commentIndex].attachments.findIndex(file => file.file_id === payload.file_id)
        if (fileIndex > -1) {
            state.jobComments[commentIndex].attachments.splice(fileIndex, 1)
        }
    },

    [VUEX_JOB_REMOVE_CHECKED_FILES_CONFIRM]: (state, payload) => {
        state.jobRemovedCheckedFilesToggler = Math.random()
    },


    //TO DO
    [VUEX_JOB_PRINT_GET_REQUEST_SUCCESS]: (state, payload) => {
    },

    //SET CANCELS
    [VUEX_JOBS_SET_CANCEL]: (state, payload) => {
        state.cancels[payload.key] = payload.value
    },

}

export default {
    state,
    getters,
    actions,
    mutations,
}
